// import React, { useEffect, useState } from "react";
// import {
//     Document,
//     Page,
//     Text,
//     View,
//     Image,
//     StyleSheet,
//     Font,
// } from "@react-pdf/renderer";
// import { Link } from "react-router-dom";

// // Define styles
// const styles = StyleSheet.create({
//     page: {
//         backgroundColor: '#FFFFFF',
//         position: 'relative'
//     },
//     logoImageContainer: {
//         position: 'relative',
//         left: '10%',
//         width: '20%',
//         // paddingLeft: '2%',
//         height: '10%',
//         padding: '2px',
//         display:'flex',
//         justifyContent: 'center',
//         alignItems:'center',

//     },
//     logoImage: {
//         width: '100%',
//         height: 'auto',
//         objectFit: 'cover',

//     },
//     firstPageUpperContainer: {
//         position: 'absolute',
//         top: 0,
//         right: '10%',
//         backgroundColor: '#f8d4c1',
//         width: '50%',
//         height: '10%',
//     },
//     firstPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '80%',
//         position: 'absolute',
//         top: '10%',
//         left: '10%',
//     },
//     firstPageMainImageContainer: {
//         position: 'relative',
//         top: '10%',
//         left: '10%',
//         height: '40%',
//         width: '80%',
//     },
//     firstPageMainImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     firstPageContentBox: {
//         position: 'absolute',
//         bottom: '10%',
//         left: '10%',
//         width: '80%',
//         height: '30%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: "space-evenly",
//         alignItems: 'left',
//         margin: 'auto',

//     },
//     customerNameContainer: {
//         // display:'flex',
//         // flexDirection: 'row'
//     },
//     greeting: {
//         fontSize: 20,
//         color: "",
//         // marginTop: 'auto',
//         // paddingBottom: '5px',
//         fontWeight: 'bold'
//     },
//     customerName: {
//         fontSize: 40,
//         fontWeight: 'bold',
//         color: "black"

//     },
//     CustomerMessage: {
//         // textAlign: 'center',
//         fontSize: 15,
//         color: "grey"
//     },
//     firstPageRightContainer: {
//         position: 'absolute',
//         bottom: '30%',
//         right: 0,
//         backgroundColor: '#f8d4c1',
//         width: '30%',
//         height: '5%',
//     },
//     firstPageBottomContainer: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '100%',
//         height: '10%',
//     },
//     // For Second Page =>
//     secondPageRightContainer: {
//         position: 'absolute',
//         top: 0,
//         right: 0,
//         backgroundColor: '#f8d4c1',
//         width: '40%',
//         height: '100%',
//     },
//     secondPageImageContainer: {
//         position: 'relative',
//         top: '23%',
//         left: '10%',
//         height: '40%',
//         width: '80%',
//     },
//     secondPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     secondPageProductNameContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '10%',
//         width: '80%'

//     },
//     secondPageProductName: {
//         fontSize: 35,
//     },
//     secondPageBottomContainer: {
//         position: 'absolute',
//         left: '10%',
//         bottom: '0%',
//         width: '70%',
//         height: '40%',
//         display: 'flex',
//         justifyContent: 'space-evenly'
//     },

//     secondPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     secondPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },

//     // For Third Page =>

//     thirdPageLeftContainer: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '60%',
//         height: '100%',
//     },
//     thirdPageImageContainer: {
//         position: 'relative',
//         top: "60%",
//         left: 0,
//         height: '40%',
//         width: '60%',
//     },
//     thirdPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     thirdPageProductNameContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '10%',
//         width: '80%'

//     },
//     thirdPageProductName: {
//         fontSize: 35,
//     },
//     thirdPageContentContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '10%',
//         width: '45%',
//         height: '40%',
//         display: 'flex',
//         justifyContent: 'space-evenly'
//     },

//     thirdPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     thirdPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//         textAlign: 'center'
//     },
//     thirdPageRotatedContainerProductPrice: {
//         position: 'absolute',
//         top: 0,
//         right: '10%',
//         width: '30%',
//         height: '60%',
//         transform: 'rotate(90deg)',
//         width: 'auto',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//     },
//     // For Fourth Page =>

//     fourthPageImageContainer: {
//         position: 'relative',
//         top: '30%',
//         left: '10%',
//         height: '50%',
//         width: '80%',
//     },
//     fourthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     fourthPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '10%',
//         width: '80%',
//         height: '30%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },

//     fourthPageProductName: {
//         fontSize: 35,
//     },
//     fourthPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '100%',

//     },
//     fourthPageLeftContainer: {
//         position: 'absolute',
//         bottom: '7.5%',
//         left: '10%',
//         backgroundColor: '#f8d4c1',
//         width: '50%',
//         height: '5%',
//     },
//     fourthPageBottomContainer: {
//         position: 'absolute',
//         right: '10%',
//         bottom: '1.5%',
//         width: '20%',
//         height: '10%',

//     },

//     fourthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     fourthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },

//     // For Fifth Page =>
//     fifthPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '15%',
//         width: '70%',
//         height: '40%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         textAlign: 'center'
//     },

//     fifthPageProductName: {
//         fontSize: 35,
//     },

//     fifthPageBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '100%',
//         height: '100%',
//     },
//     fifthPageBottomContainer: {
//         position: 'absolute',
//         right: '10%',
//         bottom: '1.5%',
//         width: '20%',
//         height: '10%',

//     },

//     fifthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     fifthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },
//     fifthPageImageContainer: {
//         position: 'relative',
//         top: '40%',
//         left: '10%',
//         height: '50%',
//         width: '80%',
//     },
//     fifthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },

//     // For sixth Page =>
//     sixthPageImageContainer: {
//         position: 'relative',
//         top: '25%',
//         left: '50%',
//         height: '60%',
//         width: '50%',
//     },
//     sixthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     sixthPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '10%',
//         width: '80%',
//         height: '25%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },

//     sixthPageProductName: {
//         fontSize: 35,
//     },
//     sixthPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '100%',

//     },
//     sixthPageBottomContainer: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '100%',
//         height: '60%',
//     },
//     sixthPageLeftContainer: {
//         position: 'absolute',
//         left: '10%',
//         bottom: '20%',
//         width: '20%',
//         height: '10%',

//     },

//     sixthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     sixthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },
//     // For seventh Page =>

//     seventhPageTopContainerBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '20%',
//         backgroundColor: '#f8d4c1',

//     },
//     seventhPageImageContainer: {
//         position: 'relative',
//         top: '30%',
//         left: '10%',
//         height: '40%',
//         width: '80%',
//     },
//     seventhPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     seventhPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '10%',
//         width: '80%',
//         height: '20%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         textAlign: 'center'
//     },

//     seventhPageProductName: {
//         fontSize: 35,
//     },
//     seventhPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '100%',

//     },
//     seventhPageLeftContainer: {
//         position: 'absolute',
//         bottom: '7.5%',
//         left: '10%',
//         backgroundColor: '#f8d4c1',
//         width: '50%',
//         height: '5%',
//     },
//     seventhPageBottomContainer: {
//         position: 'absolute',
//         right: '10%',
//         bottom: '1.5%',
//         width: '20%',
//         height: '10%',

//     },
//     seventhPageProdutDescriptionContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '75%',
//         width: '80%',
//         height: '10%',
//     },

//     seventhPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     seventhPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },

//     // For Eighth Page =>
//     eighthPageRightContainer: {
//         position: 'absolute',
//         top: 0,
//         right: 0,
//         backgroundColor: '#f8d4c1',
//         width: '40%',
//         height: '100%',
//     },
//     eighthPageImageContainer: {
//         position: 'relative',
//         top: '23%',
//         left: '10%',
//         height: '40%',
//         width: '80%',
//     },
//     eighthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     eighthPageProductNameContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '10%',
//         width: '80%',
//     },
//     eighthPageProductName: {
//         fontSize: 35,
//     },
//     eighthPageBottomContainer: {
//         position: 'absolute',
//         left: '10%',
//         bottom: '0%',
//         width: '70%',
//         height: '40%',
//         display: 'flex',
//         justifyContent: 'space-evenly'
//     },
//     eighthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     eighthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },

//     // For Ninth Page =>
//     ninthPageLeftContainer: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '60%',
//         height: '100%',
//     },
//     ninthPageImageContainer: {
//         position: 'relative',
//         top: "60%",
//         left: 0,
//         height: '40%',
//         width: '60%',
//     },
//     ninthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     ninthPageProductNameContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '10%',
//         width: '80%',
//     },
//     ninthPageProductName: {
//         fontSize: 35,
//     },
//     ninthPageContentContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '10%',
//         width: '45%',
//         height: '40%',
//         display: 'flex',
//         justifyContent: 'space-evenly'
//     },
//     ninthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     ninthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//         textAlign: 'center'
//     },
//     ninthPageRotatedContainerProductPrice: {
//         position: 'absolute',
//         top: 0,
//         right: '10%',
//         width: '30%',
//         height: '60%',
//         transform: 'rotate(90deg)',
//         width: 'auto',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//     },

//     // For Tenth Page =>
//     tenthPageImageContainer: {
//         position: 'relative',
//         top: '30%',
//         left: '10%',
//         height: '50%',
//         width: '80%',
//     },
//     tenthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     tenthPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '10%',
//         width: '80%',
//         height: '30%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     tenthPageProductName: {
//         fontSize: 35,
//     },
//     tenthPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '100%',
//     },
//     tenthPageLeftContainer: {
//         position: 'absolute',
//         bottom: '7.5%',
//         left: '10%',
//         backgroundColor: '#f8d4c1',
//         width: '50%',
//         height: '5%',
//     },
//     tenthPageBottomContainer: {
//         position: 'absolute',
//         right: '10%',
//         bottom: '1.5%',
//         width: '20%',
//         height: '10%',
//     },
//     tenthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     tenthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },

//     // For Eleventh Page =>
//     eleventhPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '15%',
//         width: '70%',
//         height: '40%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         textAlign: 'center'
//     },
//     eleventhPageProductName: {
//         fontSize: 35,
//     },
//     eleventhPageBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '100%',
//         height: '100%',
//     },
//     eleventhPageBottomContainer: {
//         position: 'absolute',
//         right: '10%',
//         bottom: '1.5%',
//         width: '20%',
//         height: '10%',
//     },
//     eleventhPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     eleventhPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },
//     eleventhPageImageContainer: {
//         position: 'relative',
//         top: '40%',
//         left: '10%',
//         height: '50%',
//         width: '80%',
//     },
//     eleventhPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },

//     // For Twelfth Page =>
//     twelfthPageImageContainer: {
//         position: 'relative',
//         top: '25%',
//         left: '50%',
//         height: '60%',
//         width: '50%',
//     },
//     twelfthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     twelfthPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '10%',
//         width: '80%',
//         height: '25%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//     },
//     twelfthPageProductName: {
//         fontSize: 35,
//     },
//     twelfthPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '100%',
//     },
//     twelfthPageBottomContainer: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '100%',
//         height: '60%',
//     },
//     twelfthPageLeftContainer: {
//         position: 'absolute',
//         left: '10%',
//         bottom: '20%',
//         width: '20%',
//         height: '10%',
//     },
//     twelfthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     twelfthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },

//     // For Thirteenth Page =>
//     thirteenthPageTopContainerBackground: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '20%',
//         backgroundColor: '#f8d4c1',
//     },
//     thirteenthPageImageContainer: {
//         position: 'relative',
//         top: '30%',
//         left: '10%',
//         height: '40%',
//         width: '80%',
//     },
//     thirteenthPageImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: 'cover',
//     },
//     thirteenthPageTopContainer: {
//         position: 'absolute',
//         top: '0%',
//         left: '10%',
//         width: '80%',
//         height: '20%',
//         display: 'flex',
//         justifyContent: 'space-evenly',
//         textAlign: 'center'
//     },
//     thirteenthPageProductName: {
//         fontSize: 35,
//     },
//     thirteenthPageTopLine: {
//         height: '1px',
//         backgroundColor: 'black',
//         width: '100%',
//     },
//     thirteenthPageLeftContainer: {
//         position: 'absolute',
//         bottom: '7.5%',
//         left: '10%',
//         backgroundColor: '#f8d4c1',
//         width: '50%',
//         height: '5%',
//     },
//     thirteenthPageBottomContainer: {
//         position: 'absolute',
//         right: '10%',
//         bottom: '1.5%',
//         width: '20%',
//         height: '10%',
//     },
//     thirteenthPageProdutDescriptionContainer: {
//         position: 'absolute',
//         left: '10%',
//         top: '75%',
//         width: '80%',
//         height: '10%',
//     },
//     thirteenthPageProdutDescription: {
//         fontSize: 15,
//         color: 'grey',
//     },
//     thirteenthPageProductPrice: {
//         fontWeight: 'bold',
//         fontSize: 25,
//     },

//     // Last Page Style =>

//     lastPageBackground: {
//         position: 'absolute',
//         bottom: 0,
//         left: 0,
//         backgroundColor: '#f8d4c1',
//         width: '100%',
//         height: '50%',
//     },

//     lastPageLogoImageContainer: {
//         position: 'relative',
//         top: '-20%',
//         width: '40%',
//         height: 'auto',
//         margin: 'auto',
//     },

//     lastPageContentContainer: {
//         position: 'absolute',
//         bottom: 0,
//         left: '20%',
//         width: '60%',
//         height: '50%',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         flexWrap: 'wrap',
//         textAlign: 'center',
//         gap: 15,
//     },
//     lastPageManagerDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         width: '100%',
//         fontSize: 15,

//     },
//     lastPageManagerNameAndNumberContainer: {
//         display: 'flex',
//         flexDirection: 'row',
//         justifyContent: 'center',
//         gap: '30px'
//     },
//     lastPageStoreDetailsContainer: {
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 10,
//         fontSize: 15,

//     },
//     lastpageCopyright: {
//         margin: 'auto',
//         fontSize: 10,
//     },
//     socialLinks: {
//         flexDirection: 'row',
//         justifyContent: 'center',
//         gap: 10,
//         marginTop: 80,
//     },
//     icon: {
//         width: 24,
//         height: 24,
//     },

// });

// function EleganceUnfolded({ jsonData, vendor }) {
//     const [Data, setData] = useState();

//     useEffect(() => {
//         setData(jsonData);
//     }, [jsonData]);

//     console.log("This is the data of EleganceUnfolded :=>", Data);
//     console.log("IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", Data?.Product?.[0]?.image)
//     return (
//         <Document>
//             <Page size="A4" style={styles.page}>

//                 <View style={styles.firstPageUpperContainer} />
//                 <View style={styles.firstPageRightContainer} />
//                 <View style={styles.firstPageBottomContainer} />
//                 <View style={styles.firstPageTopLine} />

//                 <View style={styles.logoImageContainer}>
//                     <Image
//                         style={styles.logoImage}
//                         src="/logo.png"
//                     />
//                 </View>
//                 <View style={styles.firstPageMainImageContainer}>
//                     <Image
//                         style={styles.firstPageMainImage}
//                         src="/image/frontPageImage.jpg"
//                         // src="/image/frontPageImage.jpg"
//                     />
//                 </View>
//                 <View style={[styles.firstPageContentBox]} >
//                     <View style={[styles.customerNameContainer]} >
//                         <Text style={styles.greeting}>Hello, </Text>
//                         <Text style={styles.customerName}>{Data?.Customer?.customerName}</Text>
//                     </View>
//                     <Text style={styles.CustomerMessage}>Based on your interests and recent activities, we’ve carefully curated a range of items that we believe you’ll love. Whether you’re looking for something specific or just browsing, we hope you find inspiration within these pages.</Text>
//                 </View>
//             </Page>

//             {/* Second Page */}
//             {/* {Data?.Product?.length > 0 && ( */}
//             <Page size="A4" style={styles.page}>
//                 <View style={styles.secondPageRightContainer} />
//                 <View style={styles.secondPageImageContainer}>
//                     <Image
//                         style={styles.secondPageImage}
//                         src={
//                             Data?.Product?.[0]?.image && Data?.Product?.[0]?.image !== "N/A"
//                                 ? Data?.Product?.[0]?.image
//                                 : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
//                         } />
//                 </View>
//                 <View style={styles.secondPageProductNameContainer}>
//                     <Text style={styles.secondPageProductName}>{Data?.Product?.[0]?.title}</Text>
//                 </View>
//                 <View style={styles.secondPageBottomContainer}>
//                     <Text style={styles.secondPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                     <Text style={styles.secondPageProductPrice}>{Data?.Product?.[0]?.price} Rs.</Text>
//                 </View>
//             </Page>
//             {/* )} */}

//             {/* Third Page */}
//             {Data?.Product?.length > 1 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.thirdPageLeftContainer} />
//                     <View style={styles.thirdPageImageContainer}>
//                         <Image
//                             style={styles.thirdPageImage}
//                             src={
//                                 Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
//                                     ? Data?.Product?.[1]?.image
//                                     : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
//                             } />
//                     </View>
//                     <View style={styles.thirdPageContentContainer}>
//                         <Text style={styles.thirdPageProductName}>{Data?.Product?.[1]?.title}</Text>
//                         <Text style={styles.thirdPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                     </View>
//                     <View style={styles.thirdPageRotatedContainerProductPrice}>
//                         <Text style={styles.thirdPageProductPrice}>{Data?.Product?.[1]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* fourth Page */}
//             {Data?.Product?.length > 2 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.fourthPageLeftContainer} />

//                     <View style={styles.fourthPageTopContainer}>
//                         <View style={styles.fourthPageProductNameContainer}>
//                             <Text style={styles.fourthPageProductName}>{Data?.Product?.[2]?.title}</Text>
//                         </View>
//                         <View style={styles.fourthPageTopLine} />
//                         <View style={styles.fourthPageProductDescriptionContainer}>
//                             <Text style={styles.fourthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                         </View>
//                     </View>

//                     <View style={styles.fourthPageImageContainer}>
//                         <Image
//                             style={styles.fourthPageImage}

//                             src={
//                                 Data?.Product?.[2]?.image && Data?.Product?.[2]?.image !== "N/A"
//                                     ? Data?.Product?.[2]?.image
//                                     : Data?.Product?.[2]?.productImage // Fallback to Data?.Product?.[2]?.productImage
//                             }
//                         />
//                     </View>

//                     <View style={styles.fourthPageBottomContainer}>
//                         <Text style={styles.fourthPageProductPrice}>{Data?.Product?.[2]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}

//             {/* fifth Page */}
//             {Data?.Product?.length > 3 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.fifthPageBackground} />

//                     <View style={styles.fifthPageTopContainer}>
//                         <View style={styles.fifthPageProductNameContainer}>
//                             <Text style={styles.fifthPageProductName}>{Data?.Product?.[3]?.title}</Text>
//                         </View>
//                         <View style={styles.fifthPageProductDescriptionContainer}>
//                             <Text style={styles.fifthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                         </View>
//                         <View style={styles.fifthPageProductPriceContainer}>
//                             <Text style={styles.fifthPageProductPrice}>{Data?.Product?.[3]?.price} Rs.</Text>
//                         </View>
//                     </View>

//                     <View style={styles.fifthPageImageContainer}>
//                         <Image
//                             style={styles.fifthPageImage}
//                             src={
//                                 Data?.Product?.[3]?.image && Data?.Product?.[3]?.image !== "N/A"
//                                     ? Data?.Product?.[3]?.image
//                                     : Data?.Product?.[3]?.productImage // Fallback to Data?.Product?.[3]?.productImage
//                             } />
//                     </View>
//                 </Page>
//             )}
//             {/* sixth Page */}
//             {Data?.Product?.length > 4 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.sixthPageBottomContainer} />

//                     <View style={styles.sixthPageTopContainer}>
//                         <View style={styles.sixthPageProductNameContainer}>
//                             <Text style={styles.sixthPageProductName}>{Data?.Product?.[4]?.title}</Text>
//                         </View>
//                         <View style={styles.sixthPageTopLine} />
//                         <View style={styles.sixthPageProductDescriptionContainer}>
//                             <Text style={styles.sixthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                         </View>
//                     </View>

//                     <View style={styles.sixthPageImageContainer}>
//                         <Image
//                             style={styles.sixthPageImage}
//                             src={
//                                 Data?.Product?.[4]?.image && Data?.Product?.[4]?.image !== "N/A"
//                                     ? Data?.Product?.[4]?.image
//                                     : Data?.Product?.[4]?.productImage // Fallback to Data?.Product?.[4]?.productImage
//                             } />
//                     </View>

//                     <View style={styles.sixthPageLeftContainer}>
//                         <Text style={styles.sixthPageProductPrice}>{Data?.Product?.[4]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}
//             {/*seventh Page */}
//             {Data?.Product?.length > 5 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.seventhPageLeftContainer} />
//                     <View style={styles.seventhPageTopContainerBackground} />

//                     <View style={styles.seventhPageTopContainer}>
//                         <View style={styles.seventhPageProductNameContainer}>
//                             <Text style={styles.seventhPageProductName}>{Data?.Product?.[5]?.title}</Text>
//                         </View>

//                     </View>

//                     <View style={styles.seventhPageImageContainer}>
//                         <Image
//                             style={styles.seventhPageImage}
//                             src={
//                                 Data?.Product?.[5]?.image && Data?.Product?.[5]?.image !== "N/A"
//                                     ? Data?.Product?.[5]?.image
//                                     : Data?.Product?.[5]?.productImage // Fallback to Data?.Product?.[5]?.productImage
//                             } />
//                     </View>

//                     <View style={styles.seventhPageProdutDescriptionContainer}>
//                         <Text style={styles.seventhPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use. Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use. Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                     </View>

//                     <View style={styles.seventhPageBottomContainer}>

//                         <Text style={styles.seventhPageProductPrice}>{Data?.Product?.[5]?.price} Rs.</Text>            </View>
//                 </Page>
//             )}
//             {/* Eighth Page */}
//             {Data?.Product?.length > 6 && (

//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.eighthPageRightContainer} />
//                     <View style={styles.eighthPageImageContainer}>
//                         <Image
//                             style={styles.eighthPageImage}
//                             src={
//                                 Data?.Product?.[6]?.image && Data?.Product?.[6]?.image !== "N/A"
//                                     ? Data?.Product?.[6]?.image
//                                     : Data?.Product?.[6]?.productImage // Fallback to Data?.Product?.[6]?.productImage
//                             }
//                         />
//                     </View>
//                     <View style={styles.eighthPageProductNameContainer}>
//                         <Text style={styles.eighthPageProductName}>{Data?.Product?.[6]?.title}</Text>
//                     </View>
//                     <View style={styles.eighthPageBottomContainer}>
//                         <Text style={styles.eighthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                         <Text style={styles.eighthPageProductPrice}>{Data?.Product?.[6]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* Ninth Page */}
//             {Data?.Product?.length > 7 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.ninthPageLeftContainer} />
//                     <View style={styles.ninthPageImageContainer}>
//                         <Image
//                             style={styles.ninthPageImage}
//                             src={
//                                 Data?.Product?.[7]?.image && Data?.Product?.[7]?.image !== "N/A"
//                                     ? Data?.Product?.[7]?.image
//                                     : Data?.Product?.[7]?.productImage // Fallback to Data?.Product?.[7]?.productImage
//                             } />
//                     </View>
//                     <View style={styles.ninthPageContentContainer}>
//                         <Text style={styles.ninthPageProductName}>{Data?.Product?.[7]?.title}</Text>
//                         <Text style={styles.ninthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                     </View>
//                     <View style={styles.ninthPageRotatedContainerProductPrice}>
//                         <Text style={styles.ninthPageProductPrice}>{Data?.Product?.[7]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* Tenth Page */}
//             {Data?.Product?.length > 8 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.tenthPageLeftContainer} />

//                     <View style={styles.tenthPageTopContainer}>
//                         <View style={styles.tenthPageProductNameContainer}>
//                             <Text style={styles.tenthPageProductName}>{Data?.Product?.[8]?.title}</Text>
//                         </View>
//                         <View style={styles.tenthPageTopLine} />
//                         <View style={styles.tenthPageProductDescriptionContainer}>
//                             <Text style={styles.tenthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                         </View>
//                     </View>

//                     <View style={styles.tenthPageImageContainer}>
//                         <Image
//                             style={styles.tenthPageImage}
//                             src={
//                                 Data?.Product?.[8]?.image && Data?.Product?.[8]?.image !== "N/A"
//                                     ? Data?.Product?.[8]?.image
//                                     : Data?.Product?.[8]?.productImage // Fallback to Data?.Product?.[8]?.productImage
//                             } />
//                     </View>

//                     <View style={styles.tenthPageBottomContainer}>
//                         <Text style={styles.tenthPageProductPrice}>{Data?.Product?.[8]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* Eleventh Page */}
//             {Data?.Product?.length > 9 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.eleventhPageBackground} />

//                     <View style={styles.eleventhPageTopContainer}>
//                         <View style={styles.eleventhPageProductNameContainer}>
//                             <Text style={styles.eleventhPageProductName}>{Data?.Product?.[9]?.title}</Text>
//                         </View>
//                         <View style={styles.eleventhPageProductDescriptionContainer}>
//                             <Text style={styles.eleventhPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                         </View>
//                         <View style={styles.eleventhPageProductPriceContainer}>
//                             <Text style={styles.eleventhPageProductPrice}>{Data?.Product?.[9]?.price} Rs.</Text>
//                         </View>
//                     </View>

//                     <View style={styles.eleventhPageImageContainer}>
//                         <Image
//                             style={styles.eleventhPageImage}
//                             src={
//                                 Data?.Product?.[9]?.image && Data?.Product?.[9]?.image !== "N/A"
//                                     ? Data?.Product?.[9]?.image
//                                     : Data?.Product?.[9]?.productImage // Fallback to Data?.Product?.[9]?.productImage
//                             } />
//                     </View>
//                 </Page>
//             )}
//             {/* Twelfth Page */}
//             {Data?.Product?.length > 10 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.twelfthPageBottomContainer} />

//                     <View style={styles.twelfthPageTopContainer}>
//                         <View style={styles.twelfthPageProductNameContainer}>
//                             <Text style={styles.twelfthPageProductName}>{Data?.Product?.[10]?.title}</Text>
//                         </View>
//                         <View style={styles.twelfthPageTopLine} />
//                         <View style={styles.twelfthPageProductDescriptionContainer}>
//                             <Text style={styles.twelfthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                         </View>
//                     </View>

//                     <View style={styles.twelfthPageImageContainer}>
//                         <Image
//                             style={styles.twelfthPageImage}
//                             src={
//                                 Data?.Product?.[10]?.image && Data?.Product?.[10]?.image !== "N/A"
//                                     ? Data?.Product?.[10]?.image
//                                     : Data?.Product?.[10]?.productImage // Fallback to Data?.Product?.[10]?.productImage
//                             } />
//                     </View>

//                     <View style={styles.twelfthPageLeftContainer}>
//                         <Text style={styles.twelfthPageProductPrice}>{Data?.Product?.[10]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}
//             {/* Thirteenth Page */}
//             {Data?.Product?.length > 11 && (
//                 <Page size="A4" style={styles.page}>
//                     <View style={styles.thirteenthPageLeftContainer} />
//                     <View style={styles.thirteenthPageTopContainerBackground} />

//                     <View style={styles.thirteenthPageTopContainer}>
//                         <View style={styles.thirteenthPageProductNameContainer}>
//                             <Text style={styles.thirteenthPageProductName}>{Data?.Product?.[11]?.title}</Text>
//                         </View>
//                     </View>

//                     <View style={styles.thirteenthPageImageContainer}>
//                         <Image
//                             style={styles.thirteenthPageImage}
//                             src={
//                                 Data?.Product?.[11]?.image && Data?.Product?.[11]?.image !== "N/A"
//                                     ? Data?.Product?.[11]?.image
//                                     : Data?.Product?.[11]?.productImage // Fallback to Data?.Product?.[11]?.productImage
//                             } />
//                     </View>

//                     <View style={styles.thirteenthPageProdutDescriptionContainer}>
//                         <Text style={styles.thirteenthPageProdutDescription}>Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.</Text>
//                     </View>

//                     <View style={styles.thirteenthPageBottomContainer}>
//                         <Text style={styles.thirteenthPageProductPrice}>{Data?.Product?.[11]?.price} Rs.</Text>
//                     </View>
//                 </Page>
//             )}

//             {/* Last Page */}
//               <Page size="A4" style={styles.page}>
//                             {/* <View style={styles.lastPageBackground} /> */}
//                             {/* <View style={styles.lastPageUpperContainer}> */}
//                                 {/* <View style={styles.lastPageContentContainer}> */}
//                                     <View style={styles.lastPageLogoImageContainer}>
//                                         <Image
//                                             style={styles.lastPageLogoImage}
//                                             // src={(vendor?.vendorDetails?.logo?.url) ? vendor?.vendorDetails?.logo?.url : "/logo.png"}
//                                             // src="https://storage.googleapis.com/fixlabsinficonnect/documents/20241206T122850788Z-1d8e1c615e90f989f299e273e3b7bcaa%20(1).png"
//                                             src="/logo.png"
//                                         />
//                                     </View>

//                                     {/* <View style={styles.lastPageManagerDetailsContainer}>
//                                         <View style={styles.lastPageManagerNameAndNumberContainer}>
//                                             <Text style={styles.lastPageManagerName}>{Data?.Store?.managername}</Text>
//                                             <Text style={styles.lastPageManagerPhoneNumber}>{Data?.Store?.storePhone}</Text>
//                                         </View>
//                                         <View style={styles.lastPageManagerEmailContainer}>
//                                             <Text style={styles.lastPageManagerName}>Pranjal.Sengar@gmail.com</Text>
//                                         </View>
//                                     </View> */}
//                                     {/* <View style={styles.lastPageStoreDetailsContainer}> */}

//                                         {/* <View style={styles.storeLocationContainer}>
//                                             <Text style={styles.storeLocation}>{Data?.Store?.storeAddress}</Text>
//                                         </View> */}

//                                         {/* <View style={styles.socialLinks}>
//                                             <Link src="https://www.facebook.com/login.php" style={styles.iconLink}>
//                                                 <Image
//                                                     src="/images/facebookLogoBlue.png"
//                                                     style={styles.icon}
//                                                     alt="Facebook"
//                                                 />
//                                             </Link>
//                                             <Link src="https://www.instagram.com/accounts/login/" style={styles.iconLink}>
//                                                 <Image
//                                                     src="/images/instagramLogoBlue.png"
//                                                     style={styles.icon}
//                                                     alt="Instagram"
//                                                 />
//                                             </Link>
//                                             <Link src="https://x.com/i/flow/login?input_flow_data=%7B%22requested_variant%22%3A%22eyJteCI6IjIifQ%3D%3D%22%7D" style={styles.iconLink}>
//                                                 <Image
//                                                     src="/images/twitterLogoBlue.png"
//                                                     style={styles.icon}
//                                                     alt="Twitter"
//                                                 />
//                                             </Link>
//                                             <Link src="https://discord.com/login" style={styles.iconLink}>
//                                                 <Image
//                                                     src="/images/discordLogoBlue.png"
//                                                     style={styles.icon}
//                                                     alt="Discord"
//                                                 />
//                                             </Link>
//                                         </View> */}

//                                         {/* <View style={styles.storeCopyrightContainer}>
//                                             <Text style={styles.lastpageCopyright}> */}
//                                                 {/* © {new Date().getFullYear()} {vendor?.vendorDetails?.name}™. All Rights Reserved. Built with */}
//                                                 {/* © 2021-2022 Fixlabs™. All Rights Reserved. Built with */}
//                                             {/* </Text>
//                                         </View> */}

//                                     {/* </View> */}

//                                 {/* </View> */}
//                             {/* </View> */}
//                         </Page>

//         </Document>
//     )
// }

// export default EleganceUnfolded;





// import React, { useEffect, useState } from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   Image,
//   StyleSheet,
//   Font,
// } from "@react-pdf/renderer";
// import { Link } from "react-router-dom";

// // Define styles
// const styles = StyleSheet.create({
//   page: {
//     backgroundColor: "#FFFFFF",
//     position: "relative",
//   },
//   logoImageContainer: {
//     position: "relative",
//     left: "10%",
//     width: "20%",
//     // paddingLeft: '2%',
//     height: "10%",
//     padding: "2px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   logoImage: {
//     width: "100%",
//     height: "auto",
//     objectFit: "cover",
//   },
//   firstPageUpperContainer: {
//     position: "absolute",
//     top: 0,
//     right: "10%",
//     backgroundColor: "#f8d4c1",
//     width: "50%",
//     height: "10%",
//   },
//   firstPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "80%",
//     position: "absolute",
//     top: "10%",
//     left: "10%",
//   },
//   firstPageMainImageContainer: {
//     position: "relative",
//     top: "10%",
//     left: "10%",
//     height: "40%",
//     width: "80%",
//   },
//   firstPageMainImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   firstPageContentBox: {
//     position: "absolute",
//     bottom: "10%",
//     left: "10%",
//     width: "80%",
//     height: "30%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-evenly",
//     alignItems: "left",
//     margin: "auto",
//   },
//   customerNameContainer: {
//     // display:'flex',
//     // flexDirection: 'row'
//   },
//   greeting: {
//     fontSize: 20,
//     color: "",
//     // marginTop: 'auto',
//     // paddingBottom: '5px',
//     fontWeight: "bold",
//   },
//   customerName: {
//     fontSize: 40,
//     fontWeight: "bold",
//     color: "black",
//   },
//   CustomerMessage: {
//     // textAlign: 'center',
//     fontSize: 15,
//     color: "grey",
//   },
//   firstPageRightContainer: {
//     position: "absolute",
//     bottom: "30%",
//     right: 0,
//     backgroundColor: "#f8d4c1",
//     width: "30%",
//     height: "5%",
//   },
//   firstPageBottomContainer: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "10%",
//   },
//   // For Second Page =>
//   secondPageRightContainer: {
//     position: "absolute",
//     top: 0,
//     right: 0,
//     backgroundColor: "#f8d4c1",
//     width: "40%",
//     height: "100%",
//   },
//   secondPageImageContainer: {
//     position: "relative",
//     top: "23%",
//     left: "10%",
//     height: "40%",
//     width: "80%",
//   },
//   secondPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   secondPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   secondPageProductName: {
//     fontSize: 35,
//   },
//   secondPageBottomContainer: {
//     position: "absolute",
//     left: "10%",
//     bottom: "0%",
//     width: "70%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },

//   secondPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   secondPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   secondPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },

//   // For Third Page =>

//   thirdPageLeftContainer: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "60%",
//     height: "100%",
//   },
//   thirdPageImageContainer: {
//     position: "relative",
//     top: "60%",
//     left: 0,
//     height: "40%",
//     width: "60%",
//   },
//   thirdPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   thirdPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   thirdPageProductName: {
//     fontSize: 35,
//   },
//   thirdPageContentContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "45%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },

//   thirdPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   thirdPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//     textAlign: "center",
//   },
//   thirdPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textAlign: "center",
//     textDecoration: "line-through",
//   },
//   thirdPageRotatedContainerProductPrice: {
//     position: "absolute",
//     top: 0,
//     right: "10%",
//     width: "30%",
//     height: "60%",
//     transform: "rotate(90deg)",
//     width: "auto",
//     display: "flex",
//     flexDirection: "column",
//     gap: "10px",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   // For Fourth Page =>

//   fourthPageImageContainer: {
//     position: "relative",
//     top: "30%",
//     left: "10%",
//     height: "50%",
//     width: "80%",
//   },
//   fourthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   fourthPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },

//   fourthPageProductName: {
//     fontSize: 35,
//   },
//   fourthPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "100%",
//   },
//   fourthPageLeftContainer: {
//     position: "absolute",
//     bottom: "7.5%",
//     left: "10%",
//     backgroundColor: "#f8d4c1",
//     width: "50%",
//     height: "5%",
//   },
//   fourthPageBottomContainer: {
//     position: "absolute",
//     right: "10%",
//     bottom: "1.5%",
//     width: "20%",
//     height: "10%",
//   },

//   fourthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   fourthPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   fourthPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },

//   // For Fifth Page =>
//   fifthPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "15%",
//     width: "70%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//     textAlign: "center",
//   },

//   fifthPageProductName: {
//     fontSize: 35,
//   },

//   fifthPageBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "100%",
//   },
//   fifthPageBottomContainer: {
//     position: "absolute",
//     right: "10%",
//     bottom: "1.5%",
//     width: "20%",
//     height: "10%",
//   },

//   fifthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   fifthPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   fifthPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   fifthPageImageContainer: {
//     position: "relative",
//     top: "40%",
//     left: "10%",
//     height: "50%",
//     width: "80%",
//   },
//   fifthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   // For sixth Page =>
//   sixthPageImageContainer: {
//     position: "relative",
//     top: "25%",
//     left: "50%",
//     height: "60%",
//     width: "50%",
//   },
//   sixthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   sixthPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "25%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },

//   sixthPageProductName: {
//     fontSize: 35,
//   },
//   sixthPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "100%",
//   },
//   sixthPageBottomContainer: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "60%",
//   },
//   sixthPageLeftContainer: {
//     position: "absolute",
//     left: "10%",
//     bottom: "20%",
//     width: "20%",
//     height: "10%",
//   },

//   sixthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   sixthPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   sixthPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   // For seventh Page =>

//   seventhPageTopContainerBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "20%",
//     backgroundColor: "#f8d4c1",
//   },
//   seventhPageImageContainer: {
//     position: "relative",
//     top: "30%",
//     left: "10%",
//     height: "40%",
//     width: "80%",
//   },
//   seventhPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   seventhPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "20%",
//     display: "flex",
//     justifyContent: "space-evenly",
//     textAlign: "center",
//   },

//   seventhPageProductName: {
//     fontSize: 35,
//   },
//   seventhPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "100%",
//   },
//   seventhPageLeftContainer: {
//     position: "absolute",
//     bottom: "7.5%",
//     left: "10%",
//     backgroundColor: "#f8d4c1",
//     width: "50%",
//     height: "5%",
//   },
//   seventhPageBottomContainer: {
//     position: "absolute",
//     right: "10%",
//     bottom: "1.5%",
//     width: "20%",
//     height: "10%",
//   },
//   seventhPageProdutDescriptionContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "75%",
//     width: "80%",
//     height: "10%",
//   },

//   seventhPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   seventhPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   seventhPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   // For Last Page =>
//   lastPageBackground: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "50%",
//   },

//   lastPageContentContainer: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     gap: 15,
//   },

//   lastPageLogoImageContainer: {
//     width: "100px",
//     height: "auto",
//     marginBottom: 10,
//   },

//   lastPageLogoImage: {
//     width: "100%",
//     height: "auto",
//   },

//   lastPageManagerDetailsContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     fontSize: 14,
//   },

//   lastPageManagerNameAndNumberContainer: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     gap: 30,
//   },

//   lastPageManagerName: {
//     fontWeight: "bold",
//   },

//   lastPageManagerPhoneNumber: {
//     color: "#333",
//   },
// });

// function EleganceUnfolded({ jsonData, vendor }) {
//   const [Data, setData] = useState();

//   useEffect(() => {
//     setData(jsonData);
//   }, [jsonData]);

//   console.log("This is the data of EleganceUnfolded :=>", Data);
//   console.log(
//     "IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
//     Data?.Product?.[0]?.image
//   );
//   return (
//     <Document>
//       <Page size="A4" style={styles.page}>
//         <View style={styles.firstPageUpperContainer} />
//         <View style={styles.firstPageRightContainer} />
//         <View style={styles.firstPageBottomContainer} />
//         <View style={styles.firstPageTopLine} />

//         <View style={styles.logoImageContainer}>
//           <Image style={styles.logoImage} src="/blackberrysLogo.png" />
//         </View>
//         <View style={styles.firstPageMainImageContainer}>
//           <Image
//             style={styles.firstPageMainImage}
//             src="/image/frontPageImage.jpg"
//             // src="/image/frontPageImage.jpg"
//           />
//         </View>
//         <View style={[styles.firstPageContentBox]}>
//           <View style={[styles.customerNameContainer]}>
//             <Text style={styles.greeting}>Hello, </Text>
//             <Text style={styles.customerName}>
//               {Data?.Customer?.customerName}
//             </Text>
//           </View>
//           <Text style={styles.CustomerMessage}>
//             Based on your interests and recent activities, we’ve carefully
//             curated a range of items that we believe you’ll love. Whether you’re
//             looking for something specific or just browsing, we hope you find
//             inspiration within these pages.
//           </Text>
//         </View>
//       </Page>

//       {/* Second Page */}
//       {/* {Data?.Product?.length > 0 && ( */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.secondPageRightContainer} />
//         <View style={styles.secondPageImageContainer}>
//           <Image
//             style={styles.secondPageImage}
//             src={
//               Data?.Product?.[0]?.image && Data?.Product?.[0]?.image !== "N/A"
//                 ? Data?.Product?.[0]?.image
//                 : Data?.Product?.[0]?.productImage // Fallback to Data?.Product?.[0]?.productImage
//             }
//           />
//         </View>
//         <View style={styles.secondPageProductNameContainer}>
//           <Text style={styles.secondPageProductName}>
//             {Data?.Product?.[0]?.title}
//           </Text>
//         </View>
//         <View style={styles.secondPageBottomContainer}>
//           <Text style={styles.secondPageProdutDescription}>
//             Experience the perfect blend of quality and style with our
//             thoughtfully crafted products. Designed to complement your
//             lifestyle, this item ensures exceptional comfort, durability, and
//             elegance in every use.
//           </Text>
//           <Text style={styles.secondPageProductPrice}>
//             {Data?.Product?.[0]?.price} Rs.
//           </Text>
//           {Data?.Product?.[0]?.price !== Data?.Product?.[0]?.mrp && (
//             <Text style={styles.secondPageProductMRPPrice}>
//               {Data?.Product?.[0]?.mrp} Rs.
//             </Text>
//           )}
//         </View>
//       </Page>
//       {/* )} */}

//       {/* Third Page */}
//       {Data?.Product?.length > 1 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.thirdPageLeftContainer} />
//           <View style={styles.thirdPageImageContainer}>
//             <Image
//               style={styles.thirdPageImage}
//               src={
//                 Data?.Product?.[1]?.image && Data?.Product?.[1]?.image !== "N/A"
//                   ? Data?.Product?.[1]?.image
//                   : Data?.Product?.[1]?.productImage // Fallback to Data?.Product?.[1]?.productImage
//               }
//             />
//           </View>
//           <View style={styles.thirdPageContentContainer}>
//             <Text style={styles.thirdPageProductName}>
//               {Data?.Product?.[1]?.title}
//             </Text>
//             <Text style={styles.thirdPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products. Designed to complement your
//               lifestyle, this item ensures exceptional comfort, durability, and
//               elegance in every use.
//             </Text>
//           </View>
//           <View style={styles.thirdPageRotatedContainerProductPrice}>
//             <Text style={styles.thirdPageProductPrice}>
//               {Data?.Product?.[1]?.price} Rs.
//             </Text>
//             {Data?.Product?.[1]?.price !== Data?.Product?.[1]?.mrp && (
//               <Text style={styles.thirdPageProductMRPPrice}>
//                 {Data?.Product?.[1]?.mrp} Rs.
//               </Text>
//             )}
//           </View>
//         </Page>
//       )}
//       {/* fourth Page */}
//       {Data?.Product?.length > 2 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.fourthPageLeftContainer} />

//           <View style={styles.fourthPageTopContainer}>
//             <View style={styles.fourthPageProductNameContainer}>
//               <Text style={styles.fourthPageProductName}>
//                 {Data?.Product?.[2]?.title}
//               </Text>
//             </View>
//             <View style={styles.fourthPageTopLine} />
//             <View style={styles.fourthPageProductDescriptionContainer}>
//               <Text style={styles.fourthPageProdutDescription}>
//                 Experience the perfect blend of quality and style with our
//                 thoughtfully crafted products. Designed to complement your
//                 lifestyle, this item ensures exceptional comfort, durability,
//                 and elegance in every use.
//               </Text>
//             </View>
//           </View>

//           <View style={styles.fourthPageImageContainer}>
//             <Image
//               style={styles.fourthPageImage}
//               src={
//                 Data?.Product?.[2]?.image && Data?.Product?.[2]?.image !== "N/A"
//                   ? Data?.Product?.[2]?.image
//                   : Data?.Product?.[2]?.productImage // Fallback to Data?.Product?.[2]?.productImage
//               }
//             />
//           </View>

//           <View style={styles.fourthPageBottomContainer}>
//             <Text style={styles.fourthPageProductPrice}>
//               {Data?.Product?.[2]?.price} Rs.
//             </Text>
//             {Data?.Product?.[2]?.price !== Data?.Product?.[2]?.mrp && (
//               <Text style={styles.fourthPageProductMRPPrice}>
//                 {Data?.Product?.[2]?.mrp} Rs.
//               </Text>
//             )}
//           </View>
//         </Page>
//       )}

//       {/* fifth Page */}
//       {Data?.Product?.length > 3 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.fifthPageBackground} />

//           <View style={styles.fifthPageTopContainer}>
//             <View style={styles.fifthPageProductNameContainer}>
//               <Text style={styles.fifthPageProductName}>
//                 {Data?.Product?.[3]?.title}
//               </Text>
//             </View>
//             <View style={styles.fifthPageProductDescriptionContainer}>
//               <Text style={styles.fifthPageProdutDescription}>
//                 Experience the perfect blend of quality and style with our
//                 thoughtfully crafted products. Designed to complement your
//                 lifestyle, this item ensures exceptional comfort, durability,
//                 and elegance in every use.
//               </Text>
//             </View>
//             <View style={styles.fifthPageProductPriceContainer}>
//               <Text style={styles.fifthPageProductPrice}>
//                 {Data?.Product?.[3]?.price} Rs.
//               </Text>
//               {Data?.Product?.[3]?.price !== Data?.Product?.[3]?.mrp && (
//                 <Text style={styles.fifthPageProductMRPPrice}>
//                   {Data?.Product?.[3]?.mrp} Rs.
//                 </Text>
//               )}
//             </View>
//           </View>

//           <View style={styles.fifthPageImageContainer}>
//             <Image
//               style={styles.fifthPageImage}
//               src={
//                 Data?.Product?.[3]?.image && Data?.Product?.[3]?.image !== "N/A"
//                   ? Data?.Product?.[3]?.image
//                   : Data?.Product?.[3]?.productImage // Fallback to Data?.Product?.[3]?.productImage
//               }
//             />
//           </View>
//         </Page>
//       )}
//       {/* sixth Page */}
//       {Data?.Product?.length > 4 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.sixthPageBottomContainer} />

//           <View style={styles.sixthPageTopContainer}>
//             <View style={styles.sixthPageProductNameContainer}>
//               <Text style={styles.sixthPageProductName}>
//                 {Data?.Product?.[4]?.title}
//               </Text>
//             </View>
//             <View style={styles.sixthPageTopLine} />
//             <View style={styles.sixthPageProductDescriptionContainer}>
//               <Text style={styles.sixthPageProdutDescription}>
//                 Experience the perfect blend of quality and style with our
//                 thoughtfully crafted products. Designed to complement your
//                 lifestyle, this item ensures exceptional comfort, durability,
//                 and elegance in every use.
//               </Text>
//             </View>
//           </View>

//           <View style={styles.sixthPageImageContainer}>
//             <Image
//               style={styles.sixthPageImage}
//               src={
//                 Data?.Product?.[4]?.image && Data?.Product?.[4]?.image !== "N/A"
//                   ? Data?.Product?.[4]?.image
//                   : Data?.Product?.[4]?.productImage // Fallback to Data?.Product?.[4]?.productImage
//               }
//             />
//           </View>

//           <View style={styles.sixthPageLeftContainer}>
//             <Text style={styles.sixthPageProductPrice}>
//               {Data?.Product?.[4]?.price} Rs.
//             </Text>
//             {Data?.Product?.[4]?.price !== Data?.Product?.[4]?.mrp && (
//               <Text style={styles.sixthPageProductMRPPrice}>
//                 {Data?.Product?.[4]?.mrp} Rs.
//               </Text>
//             )}
//           </View>
//         </Page>
//       )}
//       {/*seventh Page */}
//       {Data?.Product?.length > 5 && (
//         <Page size="A4" style={styles.page}>
//           <View style={styles.seventhPageLeftContainer} />
//           <View style={styles.seventhPageTopContainerBackground} />

//           <View style={styles.seventhPageTopContainer}>
//             <View style={styles.seventhPageProductNameContainer}>
//               <Text style={styles.seventhPageProductName}>
//                 {Data?.Product?.[5]?.title}
//               </Text>
//             </View>
//           </View>

//           <View style={styles.seventhPageImageContainer}>
//             <Image
//               style={styles.seventhPageImage}
//               src={
//                 Data?.Product?.[5]?.image && Data?.Product?.[5]?.image !== "N/A"
//                   ? Data?.Product?.[5]?.image
//                   : Data?.Product?.[5]?.productImage // Fallback to Data?.Product?.[5]?.productImage
//               }
//             />
//           </View>

//           <View style={styles.seventhPageProdutDescriptionContainer}>
//             <Text style={styles.seventhPageProdutDescription}>
//               Experience the perfect blend of quality and style with our
//               thoughtfully crafted products. Designed to complement your
//               lifestyle, this item ensures exceptional comfort, durability, and
//               elegance in every use. Experience the perfect blend of quality and
//               style with our thoughtfully crafted products. Designed to
//               complement your lifestyle, this item ensures exceptional comfort,
//               durability, and elegance in every use. Experience the perfect
//               blend of quality and style with our thoughtfully crafted products.
//               Designed to complement your lifestyle, this item ensures
//               exceptional comfort, durability, and elegance in every use.
//             </Text>
//           </View>

//           <View style={styles.seventhPageBottomContainer}>
//             <Text style={styles.seventhPageProductPrice}>
//               {Data?.Product?.[5]?.price} Rs.
//             </Text>
//             <Text style={styles.seventhPageProductMRPPrice}>
//               {Data?.Product?.[5]?.mrp} Rs.
//             </Text>
//           </View>
//         </Page>
//       )}
//       {/* Last Page */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.lastPageBackground}>
//           <View style={styles.lastPageContentContainer}>
//             <View style={styles.lastPageLogoImageContainer}>
//               <Image
//                 style={styles.lastPageLogoImage}
//                 src="/blackberrysLogo.png"
//               />
//             </View>

//             <View style={styles.lastPageManagerDetailsContainer}>
//               <View style={styles.lastPageManagerNameAndNumberContainer}>
//                 <Text style={styles.lastPageManagerName}>
//                   {Data?.Store?.storename}
//                 </Text>
//                 <Text style={styles.lastPageManagerPhoneNumber}>
//                   {Data?.Store?.storePhone}
//                 </Text>
//               </View>
//             </View>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
// }

// export default EleganceUnfolded;









// import React, { useEffect, useState } from "react";
// import {
//   Document,
//   Page,
//   Text,
//   View,
//   Image,
//   StyleSheet,
//   Font,
// } from "@react-pdf/renderer";
// import { Link } from "react-router-dom";

// // Define styles
// const styles = StyleSheet.create({
//   page: {
//     backgroundColor: "#FFFFFF",
//     position: "relative",
//   },
//   logoImageContainer: {
//     position: "relative",
//     left: "10%",
//     width: "20%",
//     // paddingLeft: '2%',
//     height: "10%",
//     padding: "2px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   logoImage: {
//     width: "100%",
//     height: "auto",
//     objectFit: "cover",
//   },
//   firstPageUpperContainer: {
//     position: "absolute",
//     top: 0,
//     right: "10%",
//     backgroundColor: "#f8d4c1",
//     width: "50%",
//     height: "10%",
//   },
//   firstPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "80%",
//     position: "absolute",
//     top: "10%",
//     left: "10%",
//   },
//   firstPageMainImageContainer: {
//     position: "relative",
//     top: "10%",
//     left: "10%",
//     height: "40%",
//     width: "80%",
//   },
//   firstPageMainImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   firstPageContentBox: {
//     position: "absolute",
//     bottom: "10%",
//     left: "10%",
//     width: "80%",
//     height: "30%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "space-evenly",
//     alignItems: "left",
//     margin: "auto",
//   },
//   customerNameContainer: {
//     // display:'flex',
//     // flexDirection: 'row'
//   },
//   greeting: {
//     fontSize: 20,
//     color: "",
//     // marginTop: 'auto',
//     // paddingBottom: '5px',
//     fontWeight: "bold",
//   },
//   customerName: {
//     fontSize: 40,
//     fontWeight: "bold",
//     color: "black",
//   },
//   CustomerMessage: {
//     // textAlign: 'center',
//     fontSize: 15,
//     color: "grey",
//   },
//   firstPageRightContainer: {
//     position: "absolute",
//     bottom: "30%",
//     right: 0,
//     backgroundColor: "#f8d4c1",
//     width: "30%",
//     height: "5%",
//   },
//   firstPageBottomContainer: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "10%",
//   },
//   // For Second Page =>
//   secondPageRightContainer: {
//     position: "absolute",
//     top: 0,
//     right: 0,
//     backgroundColor: "#f8d4c1",
//     width: "40%",
//     height: "100%",
//   },
//   secondPageImageContainer: {
//     position: "relative",
//     top: "23%",
//     left: "10%",
//     height: "40%",
//     width: "80%",
//   },
//   secondPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   secondPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   secondPageProductName: {
//     fontSize: 35,
//   },
//   secondPageBottomContainer: {
//     position: "absolute",
//     left: "10%",
//     bottom: "0%",
//     width: "70%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   secondPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   secondPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   secondPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   // For Third Page =>
//   thirdPageLeftContainer: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "60%",
//     height: "100%",
//   },
//   thirdPageImageContainer: {
//     position: "relative",
//     top: "60%",
//     left: 0,
//     height: "40%",
//     width: "60%",
//   },
//   thirdPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   thirdPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   thirdPageProductName: {
//     fontSize: 35,
//   },
//   thirdPageContentContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "45%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   thirdPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   thirdPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//     textAlign: "center",
//   },
//   thirdPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textAlign: "center",
//     textDecoration: "line-through",
//   },
//   thirdPageRotatedContainerProductPrice: {
//     position: "absolute",
//     top: 0,
//     right: "10%",
//     width: "30%",
//     height: "60%",
//     transform: "rotate(90deg)",
//     width: "auto",
//     display: "flex",
//     flexDirection: "column",
//     gap: "10px",
//     justifyContent: "center",
//     alignItems: "center",
//   },
//   // For Fourth Page =>
//   fourthPageImageContainer: {
//     position: "relative",
//     top: "30%",
//     left: "10%",
//     height: "50%",
//     width: "80%",
//   },
//   fourthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   fourthPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "30%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   fourthPageProductName: {
//     fontSize: 35,
//   },
//   fourthPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "100%",
//   },
//   fourthPageLeftContainer: {
//     position: "absolute",
//     bottom: "7.5%",
//     left: "10%",
//     backgroundColor: "#f8d4c1",
//     width: "50%",
//     height: "5%",
//   },
//   fourthPageBottomContainer: {
//     position: "absolute",
//     right: "10%",
//     bottom: "1.5%",
//     width: "20%",
//     height: "10%",
//   },
//   fourthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   fourthPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   fourthPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   fourthPageProductDescriptionContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   // For Fifth Page =>
//   fifthPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "15%",
//     width: "70%",
//     height: "40%",
//     display: "flex",
//     justifyContent: "space-evenly",
//     textAlign: "center",
//   },
//   fifthPageProductName: {
//     fontSize: 35,
//   },
//   fifthPageBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "100%",
//   },
//   fifthPageBottomContainer: {
//     position: "absolute",
//     right: "10%",
//     bottom: "1.5%",
//     width: "20%",
//     height: "10%",
//   },
//   fifthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   fifthPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   fifthPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   fifthPageImageContainer: {
//     position: "relative",
//     top: "40%",
//     left: "10%",
//     height: "50%",
//     width: "80%",
//   },
//   fifthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   fifthPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   fifthPageProductDescriptionContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   fifthPageProductPriceContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   // For sixth Page =>
//   sixthPageImageContainer: {
//     position: "relative",
//     top: "25%",
//     left: "50%",
//     height: "60%",
//     width: "50%",
//   },
//   sixthPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   sixthPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "25%",
//     display: "flex",
//     justifyContent: "space-evenly",
//   },
//   sixthPageProductName: {
//     fontSize: 35,
//   },
//   sixthPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "100%",
//   },
//   sixthPageBottomContainer: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "60%",
//   },
//   sixthPageLeftContainer: {
//     position: "absolute",
//     left: "10%",
//     bottom: "20%",
//     width: "20%",
//     height: "10%",
//   },
//   sixthPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   sixthPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   sixthPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   sixthPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   sixthPageProductDescriptionContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   // For seventh Page =>
//   seventhPageTopContainerBackground: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "20%",
//     backgroundColor: "#f8d4c1",
//   },
//   seventhPageImageContainer: {
//     position: "relative",
//     top: "30%",
//     left: "10%",
//     height: "40%",
//     width: "80%",
//   },
//   seventhPageImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },
//   seventhPageTopContainer: {
//     position: "absolute",
//     top: "0%",
//     left: "10%",
//     width: "80%",
//     height: "20%",
//     display: "flex",
//     justifyContent: "space-evenly",
//     textAlign: "center",
//   },
//   seventhPageProductName: {
//     fontSize: 35,
//   },
//   seventhPageTopLine: {
//     height: "1px",
//     backgroundColor: "black",
//     width: "100%",
//   },
//   seventhPageLeftContainer: {
//     position: "absolute",
//     bottom: "7.5%",
//     left: "10%",
//     backgroundColor: "#f8d4c1",
//     width: "50%",
//     height: "5%",
//   },
//   seventhPageBottomContainer: {
//     position: "absolute",
//     right: "10%",
//     bottom: "1.5%",
//     width: "20%",
//     height: "10%",
//   },
//   seventhPageProdutDescriptionContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "75%",
//     width: "80%",
//     height: "10%",
//   },
//   seventhPageProdutDescription: {
//     fontSize: 15,
//     color: "grey",
//   },
//   seventhPageProductPrice: {
//     fontWeight: "bold",
//     fontSize: 25,
//   },
//   seventhPageProductMRPPrice: {
//     fontWeight: "bold",
//     fontSize: 15,
//     textDecoration: "line-through",
//   },
//   seventhPageProductNameContainer: {
//     position: "absolute",
//     left: "10%",
//     top: "10%",
//     width: "80%",
//   },
//   // For Last Page =>
//   lastPageBackground: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     backgroundColor: "#f8d4c1",
//     width: "100%",
//     height: "50%",
//   },
//   lastPageContentContainer: {
//     position: "absolute",
//     bottom: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//     textAlign: "center",
//     gap: 15,
//   },
//   lastPageLogoImageContainer: {
//     width: "100px",
//     height: "auto",
//     marginBottom: 10,
//   },
//   lastPageLogoImage: {
//     width: "100%",
//     height: "auto",
//   },
//   lastPageManagerDetailsContainer: {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     fontSize: 14,
//   },
//   lastPageManagerNameAndNumberContainer: {
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "center",
//     gap: 30,
//   },
//   lastPageManagerName: {
//     fontWeight: "bold",
//   },
//   lastPageManagerPhoneNumber: {
//     color: "#333",
//   },
// });

// function EleganceUnfolded({ jsonData, vendor }) {
//   const [Data, setData] = useState();

//   useEffect(() => {
//     setData(jsonData);
//   }, [jsonData]);

//   console.log("This is the data of EleganceUnfolded :=>", Data);
//   console.log(
//     "IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
//     Data?.Product?.[0]?.image
//   );

//   const productDescription = "Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.";

//   return (
//     <Document>
//       {/* First Page - UNCHANGED */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.firstPageUpperContainer} />
//         <View style={styles.firstPageRightContainer} />
//         <View style={styles.firstPageBottomContainer} />
//         <View style={styles.firstPageTopLine} />

//         <View style={styles.logoImageContainer}>
//           <Image style={styles.logoImage} src="/blackberrysLogo.png" />
//         </View>
//         <View style={styles.firstPageMainImageContainer}>
//           <Image
//             style={styles.firstPageMainImage}
//             src="/image/frontPageImage.jpg"
//           />
//         </View>
//         <View style={[styles.firstPageContentBox]}>
//           <View style={[styles.customerNameContainer]}>
//             <Text style={styles.greeting}>Hello, </Text>
//             <Text style={styles.customerName}>
//               {Data?.Customer?.customerName}
//             </Text>
//           </View>
//           <Text style={styles.CustomerMessage}>
//             Based on your interests and recent activities, we've carefully
//             curated a range of items that we believe you'll love. Whether you're
//             looking for something specific or just browsing, we hope you find
//             inspiration within these pages.
//           </Text>
//         </View>
//       </Page>

//       {/* DYNAMIC PRODUCT PAGES - SAME EXACT DESIGN */}
//       {Data?.Product?.map((product, index) => {
//         const layoutIndex = index % 6;
//         const imageSrc = product?.image && product?.image !== "N/A" ? product?.image : product?.productImage;
//         const showMrp = product?.price !== product?.mrp;

//         switch (layoutIndex) {
//           case 0:
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.secondPageRightContainer} />
//                 <View style={styles.secondPageImageContainer}>
//                   <Image style={styles.secondPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.secondPageProductNameContainer}>
//                   <Text style={styles.secondPageProductName}>{product?.title}</Text>
//                 </View>
//                 <View style={styles.secondPageBottomContainer}>
//                   <Text style={styles.secondPageProdutDescription}>{productDescription}</Text>
//                   <Text style={styles.secondPageProductPrice}>{product?.price} Rs.</Text>
//                   {showMrp && <Text style={styles.secondPageProductMRPPrice}>MRP {product?.mrp} Rs.</Text>}
//                 </View>
//               </Page>
//             );

//           case 1:
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.thirdPageLeftContainer} />
//                 <View style={styles.thirdPageImageContainer}>
//                   <Image style={styles.thirdPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.thirdPageContentContainer}>
//                   <Text style={styles.thirdPageProductName}>{product?.title}</Text>
//                   <Text style={styles.thirdPageProdutDescription}>{productDescription}</Text>
//                 </View>
//                 <View style={styles.thirdPageRotatedContainerProductPrice}>
//                   <Text style={styles.thirdPageProductPrice}>{product?.price} Rs.</Text>
//                   {showMrp && <Text style={styles.thirdPageProductMRPPrice}>MRP {product?.mrp} Rs.</Text>}
//                 </View>
//               </Page>
//             );

//           case 2:
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.fourthPageLeftContainer} />
//                 <View style={styles.fourthPageTopContainer}>
//                   <Text style={styles.fourthPageProductName}>{product?.title}</Text>
//                   <View style={styles.fourthPageTopLine} />
//                   <Text style={styles.fourthPageProdutDescription}>{productDescription}</Text>
//                 </View>
//                 <View style={styles.fourthPageImageContainer}>
//                   <Image style={styles.fourthPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.fourthPageBottomContainer}>
//                   <Text style={styles.fourthPageProductPrice}>{product?.price} Rs.</Text>
//                   {showMrp && <Text style={styles.fourthPageProductMRPPrice}>MRP {product?.mrp} Rs.</Text>}
//                 </View>
//               </Page>
//             );

//           case 3:
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.fifthPageBackground} />
//                 <View style={styles.fifthPageTopContainer}>
//                   <Text style={styles.fifthPageProductName}>{product?.title}</Text>
//                   <Text style={styles.fifthPageProdutDescription}>{productDescription}</Text>
//                   <Text style={styles.fifthPageProductPrice}>{product?.price} Rs.</Text>
//                   {showMrp && <Text style={styles.fifthPageProductMRPPrice}>MRP {product?.mrp} Rs.</Text>}
//                 </View>
//                 <View style={styles.fifthPageImageContainer}>
//                   <Image style={styles.fifthPageImage} src={imageSrc} />
//                 </View>
//               </Page>
//             );

//           case 4:
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.sixthPageBottomContainer} />
//                 <View style={styles.sixthPageTopContainer}>
//                   <Text style={styles.sixthPageProductName}>{product?.title}</Text>
//                   <View style={styles.sixthPageTopLine} />
//                   <Text style={styles.sixthPageProdutDescription}>{productDescription}</Text>
//                 </View>
//                 <View style={styles.sixthPageImageContainer}>
//                   <Image style={styles.sixthPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.sixthPageLeftContainer}>
//                   <Text style={styles.sixthPageProductPrice}>{product?.price} Rs.</Text>
//                   {showMrp && <Text style={styles.sixthPageProductMRPPrice}>MRP {product?.mrp} Rs.</Text>}
//                 </View>
//               </Page>
//             );

//           case 5:
//             return (
//               <Page key={index} size="A4" style={styles.page}>
//                 <View style={styles.seventhPageTopContainerBackground} />
//                 <View style={styles.seventhPageTopContainer}>
//                   <Text style={styles.seventhPageProductName}>{product?.title}</Text>
//                 </View>
//                 <View style={styles.seventhPageImageContainer}>
//                   <Image style={styles.seventhPageImage} src={imageSrc} />
//                 </View>
//                 <View style={styles.seventhPageProdutDescriptionContainer}>
//                   <Text style={styles.seventhPageProdutDescription}>{productDescription}</Text>
//                 </View>
//                 <View style={styles.seventhPageBottomContainer}>
//                   <Text style={styles.seventhPageProductPrice}>{product?.price} Rs.</Text>
//                   {showMrp && <Text style={styles.seventhPageProductMRPPrice}>MRP {product?.mrp} Rs.</Text>}
//                 </View>
//               </Page>
//             );

//           default:
//             return null;
//         }
//       })}

//       {/* Last Page - UNCHANGED */}
//       <Page size="A4" style={styles.page}>
//         <View style={styles.lastPageBackground}>
//           <View style={styles.lastPageContentContainer}>
//             <View style={styles.lastPageLogoImageContainer}>
//               <Image
//                 style={styles.lastPageLogoImage}
//                 src="/blackberrysLogo.png"
//               />
//             </View>
//             <View style={styles.lastPageManagerDetailsContainer}>
//               <View style={styles.lastPageManagerNameAndNumberContainer}>
//                 <Text style={styles.lastPageManagerName}>
//                   {Data?.Store?.storename}
//                 </Text>
//                 <Text style={styles.lastPageManagerPhoneNumber}>
//                   {Data?.Store?.storePhone}
//                 </Text>
//               </View>
//             </View>
//           </View>
//         </View>
//       </Page>
//     </Document>
//   );
// }

// export default EleganceUnfolded;


















import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

// Define styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    position: "relative",
  },
  logoImageContainer: {
    position: "relative",
    left: "10%",
    width: "20%",
    height: "10%",
    padding: "2px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  logoImage: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
  },
  firstPageUpperContainer: {
    position: "absolute",
    top: 0,
    right: "10%",
    backgroundColor: "#f8d4c1",
    width: "50%",
    height: "10%",
  },
  firstPageTopLine: {
    height: "1px",
    backgroundColor: "black",
    width: "80%",
    position: "absolute",
    top: "10%",
    left: "10%",
  },
  firstPageMainImageContainer: {
    position: "relative",
    top: "10%",
    left: "10%",
    height: "40%",
    width: "80%",
  },
  firstPageMainImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  firstPageContentBox: {
    position: "absolute",
    bottom: "10%",
    left: "10%",
    width: "80%",
    height: "30%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "left",
    margin: "auto",
  },
  customerNameContainer: {},
  greeting: {
    fontSize: 20,
    color: "",
    fontWeight: "bold",
  },
  customerName: {
    fontSize: 40,
    fontWeight: "bold",
    color: "black",
  },
  CustomerMessage: {
    fontSize: 15,
    color: "grey",
  },
  firstPageRightContainer: {
    position: "absolute",
    bottom: "30%",
    right: 0,
    backgroundColor: "#f8d4c1",
    width: "30%",
    height: "5%",
  },
  firstPageBottomContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    backgroundColor: "#f8d4c1",
    width: "100%",
    height: "10%",
  },

  // NEW MRP STYLES - ONLY NUMBER STRIKETHROUGH
  mrpText: {
    color: "black",
    fontWeight: "bold",
    fontSize: 15,
    // ✅ NO line-through
  },
  mrpNumber: {
    color: "black",
    fontWeight: "bold",
    fontSize: 15,
    textDecoration: "line-through", // ✅ ONLY NUMBER CUT
  },
  priceRowContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
  },

  // For Second Page =>
  secondPageRightContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "#f8d4c1",
    width: "40%",
    height: "100%",
  },
  secondPageImageContainer: {
    position: "relative",
    top: "23%",
    left: "10%",
    height: "40%",
    width: "80%",
  },
  secondPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  secondPageProductNameContainer: {
    position: "absolute",
    left: "10%",
    top: "10%",
    width: "80%",
  },
  secondPageProductName: {
    fontSize: 35,
  },
  secondPageBottomContainer: {
    position: "absolute",
    left: "10%",
    bottom: "0%",
    width: "70%",
    height: "40%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  secondPageProdutDescription: {
    fontSize: 15,
    color: "grey",
  },
  secondPageProductPrice: {
    fontWeight: "bold",
    fontSize: 25,
    color: "black",
  },

  // For Third Page =>
  thirdPageLeftContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: "#f8d4c1",
    width: "60%",
    height: "100%",
  },
  thirdPageImageContainer: {
    position: "relative",
    top: "60%",
    left: 0,
    height: "40%",
    width: "60%",
  },
  thirdPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  thirdPageProductNameContainer: {
    position: "absolute",
    left: "10%",
    top: "10%",
    width: "80%",
  },
  thirdPageProductName: {
    fontSize: 35,
  },
  thirdPageContentContainer: {
    position: "absolute",
    left: "10%",
    top: "10%",
    width: "45%",
    height: "40%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  thirdPageProdutDescription: {
    fontSize: 15,
    color: "grey",
  },
  thirdPageProductPrice: {
    fontWeight: "bold",
    fontSize: 25,
    color: "black",
  },
  thirdPageRotatedContainerProductPrice: {
    position: "absolute",
    top: 0,
    right: "10%",
    width: "30%",
    height: "60%",
    transform: "rotate(90deg)",
    // width: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    justifyContent: "center",
    alignItems: "center",
  },

  // For Fourth Page =>
  fourthPageImageContainer: {
    position: "relative",
    top: "30%",
    left: "10%",
    height: "50%",
    width: "80%",
  },
  fourthPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  fourthPageTopContainer: {
    position: "absolute",
    top: "0%",
    left: "10%",
    width: "80%",
    height: "30%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  fourthPageProductName: {
    fontSize: 35,
  },
  fourthPageTopLine: {
    height: "1px",
    backgroundColor: "black",
    width: "100%",
  },
  fourthPageLeftContainer: {
    position: "absolute",
    bottom: "7.5%",
    left: "10%",
    backgroundColor: "#f8d4c1",
    width: "50%",
    height: "5%",
  },
  fourthPageBottomContainer: {
    position: "absolute",
    right: "10%",
    bottom: "1.5%",
    width: "20%",
    height: "10%",
  },
  fourthPageProdutDescription: {
    fontSize: 15,
    color: "grey",
  },
  fourthPageProductPrice: {
    fontWeight: "bold",
    fontSize: 25,
    color: "black",
  },

  // For Fifth Page =>
  fifthPageTopContainer: {
    position: "absolute",
    top: "0%",
    left: "15%",
    width: "70%",
    height: "40%",
    display: "flex",
    justifyContent: "space-evenly",
    textAlign: "center",
  },
  fifthPageProductName: {
    fontSize: 35,
  },
  fifthPageBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: "#f8d4c1",
    width: "100%",
    height: "100%",
  },
  fifthPageBottomContainer: {
    position: "absolute",
    right: "10%",
    bottom: "1.5%",
    width: "20%",
    height: "10%",
  },
  fifthPageProdutDescription: {
    fontSize: 15,
    color: "grey",
  },
  fifthPageProductPrice: {
    fontWeight: "bold",
    fontSize: 25,
    color: "black",
  },
  fifthPageImageContainer: {
    position: "relative",
    top: "40%",
    left: "10%",
    height: "50%",
    width: "80%",
  },
  fifthPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  fifthPageProductNameContainer: {
    position: "absolute",
    left: "10%",
    top: "10%",
    width: "80%",
  },
  fifthPageProductDescriptionContainer: {
    position: "absolute",
    left: "10%",
    top: "10%",
    width: "80%",
  },
  fifthPageProductPriceContainer: {
    position: "absolute",
    left: "10%",
    top: "10%",
    width: "80%",
  },

  // For sixth Page =>
  sixthPageImageContainer: {
    position: "relative",
    top: "25%",
    left: "50%",
    height: "60%",
    width: "50%",
  },
  sixthPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  sixthPageTopContainer: {
    position: "absolute",
    top: "0%",
    left: "10%",
    width: "80%",
    height: "25%",
    display: "flex",
    justifyContent: "space-evenly",
  },
  sixthPageProductName: {
    fontSize: 35,
  },
  sixthPageTopLine: {
    height: "1px",
    backgroundColor: "black",
    width: "100%",
  },
  sixthPageBottomContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    backgroundColor: "#f8d4c1",
    width: "100%",
    height: "60%",
  },
  sixthPageLeftContainer: {
    position: "absolute",
    left: "10%",
    bottom: "20%",
    width: "20%",
    height: "10%",
  },
  sixthPageProdutDescription: {
    fontSize: 15,
    color: "grey",
  },
  sixthPageProductPrice: {
    fontWeight: "bold",
    fontSize: 25,
    color: "black",
  },

  // For seventh Page =>
  seventhPageTopContainerBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "20%",
    backgroundColor: "#f8d4c1",
  },
  seventhPageImageContainer: {
    position: "relative",
    top: "30%",
    left: "10%",
    height: "40%",
    width: "80%",
  },
  seventhPageImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  seventhPageTopContainer: {
    position: "absolute",
    top: "0%",
    left: "10%",
    width: "80%",
    height: "20%",
    display: "flex",
    justifyContent: "space-evenly",
    textAlign: "center",
  },
  seventhPageProductName: {
    fontSize: 35,
  },
  seventhPageTopLine: {
    height: "1px",
    backgroundColor: "black",
    width: "100%",
  },
  seventhPageLeftContainer: {
    position: "absolute",
    bottom: "7.5%",
    left: "10%",
    backgroundColor: "#f8d4c1",
    width: "50%",
    height: "5%",
  },
  seventhPageBottomContainer: {
    position: "absolute",
    right: "10%",
    bottom: "1.5%",
    width: "20%",
    height: "10%",
  },
  seventhPageProdutDescriptionContainer: {
    position: "absolute",
    left: "10%",
    top: "75%",
    width: "80%",
    height: "10%",
  },
  seventhPageProdutDescription: {
    fontSize: 15,
    color: "grey",
  },
  seventhPageProductPrice: {
    fontWeight: "bold",
    fontSize: 25,
    color: "black",
  },

  // For Last Page =>
  lastPageBackground: {
    position: "absolute",
    bottom: 0,
    left: 0,
    backgroundColor: "#f8d4c1",
    width: "100%",
    height: "50%",
  },
  lastPageContentContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    gap: 15,
  },
  lastPageLogoImageContainer: {
    width: "100px",
    height: "auto",
    marginBottom: 10,
  },
  lastPageLogoImage: {
    width: "100%",
    height: "auto",
  },
  lastPageManagerDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: 14,
  },
  lastPageManagerNameAndNumberContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 30,
  },
  lastPageManagerName: {
    fontWeight: "bold",
  },
  lastPageManagerPhoneNumber: {
    color: "#333",
  },
});

function EleganceUnfolded({ jsonData, vendor }) {
  const [Data, setData] = useState();

  useEffect(() => {
    setData(jsonData);
  }, [jsonData]);

  console.log("This is the data of EleganceUnfolded :=>", Data);
  console.log(
    "IMAGE ================================================================>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
    Data?.Product?.[0]?.image
  );

  const productDescription = "Experience the perfect blend of quality and style with our thoughtfully crafted products. Designed to complement your lifestyle, this item ensures exceptional comfort, durability, and elegance in every use.";

  // Helper function to format price without decimals
  const formatPrice = (price) => {
    return Math.floor(price).toString();
  };

  return (
    <Document>
      {/* First Page - UNCHANGED */}
      <Page size="A4" style={styles.page}>
        <View style={styles.firstPageUpperContainer} />
        <View style={styles.firstPageRightContainer} />
        <View style={styles.firstPageBottomContainer} />
        <View style={styles.firstPageTopLine} />

        <View style={styles.logoImageContainer}>
          <Image style={styles.logoImage} src="/blackberrysLogo.png" />
        </View>
        <View style={styles.firstPageMainImageContainer}>
          <Image
            style={styles.firstPageMainImage}
            src="/image/frontPageImage.jpg"
          />
        </View>
        <View style={[styles.firstPageContentBox]}>
          <View style={[styles.customerNameContainer]}>
            <Text style={styles.greeting}>Hello, </Text>
            <Text style={styles.customerName}>
              {Data?.Customer?.customerName}
            </Text>
          </View>
          <Text style={styles.CustomerMessage}>
            Based on your interests and recent activities, we've carefully
            curated a range of items that we believe you'll love. Whether you're
            looking for something specific or just browsing, we hope you find
            inspiration within these pages.
          </Text>
        </View>
      </Page>

      {/* DYNAMIC PRODUCT PAGES */}
      {Data?.Product?.map((product, index) => {
        const layoutIndex = index % 6;
        const imageSrc = product?.image && product?.image !== "N/A" ? product?.image : product?.productImage;
        const showMrp = product?.price !== product?.mrp;

        switch (layoutIndex) {
          case 0:
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.secondPageRightContainer} />
                <View style={styles.secondPageImageContainer}>
                  <Image style={styles.secondPageImage} src={imageSrc} />
                </View>
                <View style={styles.secondPageProductNameContainer}>
                  <Text style={styles.secondPageProductName}>{product?.title}</Text>
                </View>
                <View style={styles.secondPageBottomContainer}>
                  <Text style={styles.secondPageProdutDescription}>{productDescription}</Text>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.secondPageProductPrice}>{formatPrice(product?.price)} Rs.</Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
              </Page>
            );

          case 1:
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.thirdPageLeftContainer} />
                <View style={styles.thirdPageImageContainer}>
                  <Image style={styles.thirdPageImage} src={imageSrc} />
                </View>
                <View style={styles.thirdPageContentContainer}>
                  <Text style={styles.thirdPageProductName}>{product?.title}</Text>
                  <Text style={styles.thirdPageProdutDescription}>{productDescription}</Text>
                </View>
                <View style={styles.thirdPageRotatedContainerProductPrice}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.thirdPageProductPrice}>{formatPrice(product?.price)} Rs.</Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
              </Page>
            );

          case 2:
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.fourthPageLeftContainer} />
                <View style={styles.fourthPageTopContainer}>
                  <Text style={styles.fourthPageProductName}>{product?.title}</Text>
                  <View style={styles.fourthPageTopLine} />
                  <Text style={styles.fourthPageProdutDescription}>{productDescription}</Text>
                </View>
                <View style={styles.fourthPageImageContainer}>
                  <Image style={styles.fourthPageImage} src={imageSrc} />
                </View>
                <View style={styles.fourthPageBottomContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.fourthPageProductPrice}>{formatPrice(product?.price)} Rs.</Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
              </Page>
            );

          case 3:
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.fifthPageBackground} />
                <View style={styles.fifthPageTopContainer}>
                  <Text style={styles.fifthPageProductName}>{product?.title}</Text>
                  <Text style={styles.fifthPageProdutDescription}>{productDescription}</Text>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.fifthPageProductPrice}>{formatPrice(product?.price)} Rs.</Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.fifthPageImageContainer}>
                  <Image style={styles.fifthPageImage} src={imageSrc} />
                </View>
              </Page>
            );

          case 4:
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.sixthPageBottomContainer} />
                <View style={styles.sixthPageTopContainer}>
                  <Text style={styles.sixthPageProductName}>{product?.title}</Text>
                  <View style={styles.sixthPageTopLine} />
                  <Text style={styles.sixthPageProdutDescription}>{productDescription}</Text>
                </View>
                <View style={styles.sixthPageImageContainer}>
                  <Image style={styles.sixthPageImage} src={imageSrc} />
                </View>
                <View style={styles.sixthPageLeftContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.sixthPageProductPrice}>{formatPrice(product?.price)} Rs.</Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
              </Page>
            );

          case 5:
            return (
              <Page key={index} size="A4" style={styles.page}>
                <View style={styles.seventhPageTopContainerBackground} />
                <View style={styles.seventhPageTopContainer}>
                  <Text style={styles.seventhPageProductName}>{product?.title}</Text>
                </View>
                <View style={styles.seventhPageImageContainer}>
                  <Image style={styles.seventhPageImage} src={imageSrc} />
                </View>
                <View style={styles.seventhPageProdutDescriptionContainer}>
                  <Text style={styles.seventhPageProdutDescription}>{productDescription}</Text>
                </View>
                <View style={styles.seventhPageBottomContainer}>
                  <View style={styles.priceRowContainer}>
                    <Text style={styles.seventhPageProductPrice}>{formatPrice(product?.price)} Rs.</Text>
                    {showMrp && (
                      <View style={{ display: "flex", flexDirection: "row", gap: 2 }}>
                        <Text style={styles.mrpText}>MRP</Text>
                        <Text style={styles.mrpNumber}>{formatPrice(product?.mrp)}</Text>
                        <Text style={styles.mrpText}>Rs.</Text>
                      </View>
                    )}
                  </View>
                </View>
              </Page>
            );

          default:
            return null;
        }
      })}

      {/* Last Page - UNCHANGED */}
      <Page size="A4" style={styles.page}>
        <View style={styles.lastPageBackground}>
          <View style={styles.lastPageContentContainer}>
            <View style={styles.lastPageLogoImageContainer}>
              <Image
                style={styles.lastPageLogoImage}
                src="/blackberrysLogo.png"
              />
            </View>
            <View style={styles.lastPageManagerDetailsContainer}>
              <View style={styles.lastPageManagerNameAndNumberContainer}>
                <Text style={styles.lastPageManagerName}>
                  {Data?.Store?.storename}
                </Text>
                <Text style={styles.lastPageManagerPhoneNumber}>
                  {Data?.Store?.storePhone}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default EleganceUnfolded;